import { VetPromptModule } from "../promptGuides";
import { WorkspacePromptEditor } from "../WorkspacePromptEditor";
import styles from "./styles.module.scss";

export function MasterPromptBlock({
  title,
  moduleId,
  aiWorkspaceId,
  noun,
  savedPrompt,
  hasPriorResults,
  isSaving,
  saveVersion,
  onSave,
}: {
  title: string;
  moduleId: VetPromptModule;
  aiWorkspaceId: string;
  noun: string;
  savedPrompt: string;
  hasPriorResults: boolean;
  isSaving: boolean;
  saveVersion: number;
  onSave: (prompt: string) => void;
}) {
  return (
    <section className={styles.masterPromptBlock}>
      <h4 className={styles.masterPromptTitle}>{title}</h4>
      <WorkspacePromptEditor
        moduleId={moduleId}
        aiWorkspaceId={aiWorkspaceId}
        label="Master prompt"
        savedPrompt={savedPrompt}
        isSaving={isSaving}
        saveVersion={saveVersion}
        hasPriorResults={hasPriorResults}
        priorResultNoun={noun}
        onSave={onSave}
      />
    </section>
  );
}
